.DiceboundModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.DiceboundModal .Header,
.DiceboundModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.DiceboundModal .Header .BigText,
.DiceboundModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText,
.DiceboundModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText[isHoverable]:hover,
.DiceboundModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.DiceboundModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiceboundModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.DiceboundModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.DiceboundModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description span,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.DiceboundModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.DiceboundModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.DiceboundModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.DiceboundModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.DiceboundModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.DiceboundModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.DiceboundModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.OverworldModal {
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  position: absolute;
  overflow: hidden;
}
.OverworldModal .Header,
.OverworldModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.OverworldModal .Header .BigText,
.OverworldModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.OverworldModal .Header .SmallText,
.OverworldModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.OverworldModal .Header .SmallText[isHoverable]:hover,
.OverworldModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.OverworldModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.OverworldModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.OverworldModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.OverworldModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.OverworldModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.OverworldModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.OverworldModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.OverworldModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.OverworldModal .UnitsSection .Unit .DraftableDice .Description,
.OverworldModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.OverworldModal .UnitsSection .Unit .DraftableDice .Description span,
.OverworldModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.OverworldModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.OverworldModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.OverworldModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.OverworldModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.OverworldModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.OverworldModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.OverworldModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.OverworldModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.OverworldModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.OverworldModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.OverworldModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.OverworldModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.OverworldModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.OverworldModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.OverworldModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.OverworldModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.OverworldModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.OverworldModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.OverworldModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.OverworldModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.OverworldModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.OverworldModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.OverworldModal .Compass {
  top: 0em;
  left: 0em;
  padding: 1em;
  z-index: 10000;
  position: absolute;
  text-align: center;
}
.OverworldModal .Compass .Subtitle {
  font-size: 0.5em;
  line-height: 1em;
  color: #817F91;
}
.OverworldModal .Compass .Title {
  font-size: 0.8em;
  line-height: 1em;
  font-family: var(--fancy-font);
}
.OverworldModal .Legend {
  right: 0em;
  bottom: 0em;
  padding: 1em;
  z-index: 10000;
  position: absolute;
}
.OverworldModal .Legend .Label {
  padding-left: 0.4em;
  margin-bottom: 0.1em;
}
.OverworldModal .Legend .Label .Value {
  font-size: 0.5em;
  line-height: 1em;
}
.OverworldModal .Legend .Item {
  display: flex;
  gap: 0.1em;
}
.OverworldModal .Legend .Item .Key,
.OverworldModal .Legend .Item .Value {
  font-size: 0.3em;
  line-height: 1em;
  color: #817F91;
}
.OverworldModal .Legend .Item .Key {
  width: 1em;
  text-align: right;
}
.OverworldModal .Images .Map,
.OverworldModal .Images .Image {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  image-rendering: pixelated;
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -ms-user-drag: none;
  user-drag: none;
}
.OverworldModal .Overworld {
  width: 11em;
  height: 5em;
  position: relative;
}
.OverworldModal .Overworld .Encounter {
  width: 0.5em;
  height: 0.5em;
  margin-top: -0.25em;
  margin-left: -0.25em;
  position: absolute;
  z-index: 30;
  border-radius: 100%;
  background-color: green;
  border-style: solid;
  border-color: #2D2D2A;
  border-width: 0.05em;
  background-color: hotpink;
  display: flex;
  align-items: center;
  justify-content: center;
}
.OverworldModal .Overworld .Encounter[isSelectable] {
  border-color: #f0ead6;
}
.OverworldModal .Overworld .Encounter[isSelectable]:hover {
  cursor: pointer;
  color: #2D2D2A;
  background-color: #f0ead6;
}
.OverworldModal .Overworld .Encounter[type="merchant"],
.OverworldModal .Overworld .Encounter[type="treasure"],
.OverworldModal .Overworld .Encounter[type="random"],
.OverworldModal .Overworld .Encounter[type="exit"] {
  background-color: #639bff;
  background-color: #0099A1;
}
.OverworldModal .Overworld .Encounter[type="first-combat"],
.OverworldModal .Overworld .Encounter[type="standard-combat"],
.OverworldModal .Overworld .Encounter[type="elite-combat"],
.OverworldModal .Overworld .Encounter[type="final-combat"] {
  background-color: #d54b33;
  background-color: #B7341A;
}
.OverworldModal .Overworld .Encounter[type="campfire"] {
  background-color: #62C370;
  background-color: #4A5C6C;
}
.OverworldModal .Overworld .Encounter .Text {
  font-size: 0.25em;
}
.OverworldModal .Overworld .Path {
  width: 1em;
  height: 0.15em;
  margin-top: -0.075em;
  position: absolute;
  z-index: 20;
  background-color: #2D2D2A;
  transform-origin: center left;
}
.OverworldModal .Overworld .Path[dy="-1"] {
  transform: rotate(-45deg);
  width: 1.25em;
}
.OverworldModal .Overworld .Path[dy="1"] {
  transform: rotate(45deg);
  width: 1.25em;
}
